import { EVENT_TYPES } from "../../data"

export const FEEDBACK_CHOICE_LABELS = {
  kudos_call: "Kudos Team--Great Call!",
  kudos_compliment: "Kudos Team--Compliments from the Agent!",
  no_show: "No Show, No Response to Multiple Follow-Up Attempts",
  cancelled: "Cancelled Before Appointment, Unresponsive to Rescheduling.",
  bad_feedback: "Bad Feedback from Agent",
  no_match: "Agent didn't meet my criteria",
}

export function isFeedbackEvent(event) {
  return event?.type === EVENT_TYPES.feedback
}

export function getFeedbackEventTitle(event) {
  return event?.action === "updated" ? "Feedback updated" : "Feedback sent"
}

export function getFeedbackEventDetail(event) {
  const choice = event?.feedback
  return {
    label: FEEDBACK_CHOICE_LABELS[choice] || choice || "",
    comments: event?.comments || "",
  }
}
